var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrame1Cards(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 315.472,
    height: 416.459,
    viewBox: "0 0 315.472 416.459",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-38.539)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(290.815)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1896.182-395.428v-65.993l-3.651-3.651v109.633l-18.869,18.869h-23.075l-7.041,7.042h33.033l22.994-22.994v-39.515Z",
    transform: "translate(-1843.545 745.987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1929.5-654.854v68.279l3.186,3.186V-549.7l-3.186,3.186v68.279l7.283-7.283v-162.05Z",
    transform: "translate(-1873.583 774.776)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1896.182-730.319v65.993l-3.651,3.651V-770.309l-18.869-18.869h-23.075l-7.041-7.042h33.033l22.994,22.994v39.516Z",
    transform: "translate(-1843.545 796.219)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1558-730.319v65.993l3.651,3.651V-770.309l18.869-18.869h23.075l7.042-7.042H1577.6l-22.994,22.994v39.516Z",
    transform: "translate(-1508.901 796.219)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1533.4-478.238v-68.279l-3.186-3.186v-33.686l3.186-3.186v-68.279l-7.283,7.283v162.049Z",
    transform: "translate(-1487.579 774.776)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1558-395.428v-65.993l3.651-3.651v109.633l18.869,18.869h23.075l7.042,7.042H1577.6l-22.994-22.994v-39.515Z",
    transform: "translate(-1508.901 745.987)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame1Cards);
export default __webpack_public_path__ + "static/media/frame1_cards.5485d5cd7a418c293d6c8d730aaf77b1.svg";
export { ForwardRef as ReactComponent };